import { ValidationStrategy } from "./validation.strategy";
import { ValidationStrategyFactory } from "./validation-strategy.factory";

export class DefaultValidationStrategy extends ValidationStrategy {

    private errorMessage = "";

    public validate(): boolean {
        let isValid = true;

        if (this.isRequired && 
            !this.isDisabled && 
            !this.isHidden &&
            !this.attribute.value) {
            isValid = false;
        }

        this.attribute.attributes.forEach(childAttribute => {
            let validator = ValidationStrategyFactory.create(childAttribute, this.injectedOptions);
            let childrenAreValid = validator.validate();

            if(!childrenAreValid) {
                this.errorMessage += `${validator.getErrorMessage()}\n`;
            }

            isValid = childrenAreValid && isValid;
        });

        this.attribute.hasError = !isValid

        return isValid;
    }

    public getErrorMessage(errorType: string = "error"): string {
        if(this.errorMessage) {
            return this.errorMessage;
        } else {
            return super.getErrorMessage(errorType);
        }
    }
}